import { ChevronRightIcon, HamburgerIcon } from '@chakra-ui/icons';
import { Box, Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, Flex, IconButton, Text, useDisclosure, VStack } from '@chakra-ui/react';
import { FiCreditCard, FiLogOut, FiStar } from 'react-icons/fi';
import { GoHome } from 'react-icons/go';
import { HiX } from 'react-icons/hi';
import { LuCrown } from 'react-icons/lu';
import { useLocation, useNavigate } from 'react-router-dom';
import { urlNavigate } from '../../../helper/utils/navigation';

export default function DashboardSidebar({ onLogout }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { isOpen, onOpen, onClose } = useDisclosure();

    const handleMenuClick = (path) => {
        onClose();

        if (path === 'logout') {
            handleLogout();
            return;
        }

        navigate(path);
    };

    const handleLogout = () => {
        if (onLogout) {
            onLogout();
        } else {
            localStorage.setItem('isVerifiedWaiver', false);
            localStorage.setItem('waiver', '{}');
            localStorage.setItem('email', '');

            navigate(`${urlNavigate('online-sales', 'home')}`);
            window.location.reload();
        }
        onClose();
    };

    // Sidebar Content Component (reusable for both drawer and desktop)
    const SidebarContent = () => {
        const menuItems = [
            { id: 'dashboard', label: 'Dashboard', icon: GoHome, path: urlNavigate('dashboard') },
            { id: 'membership', label: 'Membership', icon: LuCrown, path: urlNavigate('dashboard', 'membership') },
            { id: 'credit-balance', label: 'Transactions', icon: FiCreditCard, path: urlNavigate('dashboard', 'credit-balance') },
            { id: 'points', label: 'Loyalty Points', icon: FiStar, path: urlNavigate('dashboard', 'points') },
            // { id: 'vouchers', label: 'Vouchers', icon: FiGift, path: '/dashboard/vouchers' },
            // { id: 'coupons', label: 'Coupons', icon: FiPackage, path: '/dashboard/coupons' },
            // { id: 'orders', label: 'Orders', icon: FiShoppingBag, path: '/dashboard/orders' },
            { id: 'logout', label: 'Logout', icon: FiLogOut, path: 'logout' },
        ];

        return (
            <Flex direction='column' h='full'>
                <VStack spacing={2} align='stretch' flex={1}>
                    {menuItems.map((item) => {
                        const Icon = item.icon;
                        const isActive = location.pathname === item.path;

                        return (
                            <Button
                                key={item.id}
                                onClick={() => handleMenuClick(item.path)}
                                bg={isActive ? 'primary.700' : 'transparent'}
                                color='white'
                                justifyContent='space-between'
                                px={4}
                                py={6}
                                borderRadius='lg'
                                fontWeight='medium'
                                fontSize='md'
                                _hover={{
                                    bg: 'primary.700',
                                    transform: 'translateX(4px)',
                                }}
                                transition='all 0.2s'
                                leftIcon={<Icon size={20} />}
                                rightIcon={<ChevronRightIcon />}>
                                <Text flex={1} textAlign='left' ml={2}>
                                    {item.label}
                                </Text>
                            </Button>
                        );
                    })}
                </VStack>

                <Button
                    onClick={() => navigate(`${urlNavigate('online-sales', 'home')}`)}
                    colorScheme='whiteAlpha'
                    mt={8}
                    variant='solid'
                    py={6}
                    borderRadius='lg'
                    fontWeight='bold'
                    fontSize='sm'
                    leftIcon={<GoHome size={20} />}
                    boxShadow='none'
                    _hover={{
                        bg: 'tertiary.600',
                        transform: 'scale(1.02)',
                    }}
                    transition='all 0.2s'>
                    Buy Ticketing
                </Button>
            </Flex>
        );
    };

    return (
        <>
            {/* Mobile: Hamburger Button */}
            <Box display={{ base: 'block', md: 'none' }} position='fixed' bottom={4} right={4} zIndex={10}>
                <IconButton w='65px' h='65px' icon={isOpen ? <HiX /> : <HamburgerIcon />} fontSize='25px' onClick={onOpen} colorScheme='purple' aria-label='Open menu' size='lg' borderRadius='full' shadow='lg' />
            </Box>

            {/* Mobile: Drawer */}
            <Drawer isOpen={isOpen} placement='left' onClose={onClose} size='xs'>
                <DrawerContent bgGradient='linear(to-b, primary.500, primary.600, primary.700)' boxShadow='0 0px 0px 1000px rgba(0, 0, 0, 0.5)'>
                    <DrawerCloseButton color='white' />
                    <DrawerHeader color='white' borderBottomWidth='1px' borderColor='whiteAlpha.300'>
                        Menu
                    </DrawerHeader>
                    <DrawerBody p={4}>
                        <SidebarContent />
                    </DrawerBody>
                </DrawerContent>
            </Drawer>

            {/* Desktop: Sidebar */}
            <Box w='280px' bg='primary.500' minH='100vh' p={6} position='sticky' top={0} display={{ base: 'none', md: 'flex' }} flexDirection='column'>
                <SidebarContent />
            </Box>
        </>
    );
}
